import { lazy } from "react";


export const Campaigns = lazy(() => import("./Campaigns"));
export const SingleCampaignDetails = lazy(() => import("./SingleCampaignDetails"));
export const AddCampaigns = lazy(() => import("./AddCampaigns"));
export const EditCampaign = lazy(() => import("./EditCampaign"));
export const EditCampaignV1 = lazy(() => import("./EditCampaignV1"));
export const CampaignDetailsSection = lazy(() => import("./CampaignDetailsSection"));
